import { lighten, darken } from 'polished'
import styled from "styled-components"
import globals from "../globals"
import { H2, H5 } from "../headings/index"
import HeaderBackground from "../../images/background-header.png"
const { mediaqueries, paddingSides, colors, fonts } = globals
const { extraSmall, small, medium, large } = mediaqueries

export const EtapasGrid = styled.div`
  display: grid;
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : "1000px")};
  margin: 0 auto;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 35px;

  @media ${extraSmall} {
    grid-template-columns: 1fr;
  }

  @media ${small} {
    grid-template-columns: 1fr;
  }
`

export const EtapasWrapper = styled.div`
  scroll-margin: 92px 0 0 0;
  width: 100%;
  display: block;
  margin-top: 80px;
  margin-bottom: 95px;
  background: #113c64;
  box-shadow: inset 0 0 200px 10px rgba(0, 0, 0, 0.4);
  padding: 69px ${paddingSides.normal};
  color: white;

  @media ${small} {
    margin-bottom: 50px;
  }

  @media ${extraSmall} {
    margin-bottom: 40px;
  }

  h2,
  h3 {
    color: white;
  }

  h2 {
    text-align: center;

    & + p {
      max-width: 960px;
      text-align: center;
      font-weight: 300;
      font-size: 1.1em;
      margin: 0 auto 70px;
    }
  }

  p {
    color: white;
  }

  .logo-seguro-wrapper {
    position: relative;
    text-align: center;

    &:before {
      content: "";
      width: 80%;
      height: 60%;
      display: block;
      background: ${colors.lightblue};
      position: absolute;
      filter: blur(100px);
      left: 10%;
      top: 20%;
      z-index: 0;
    }

    img {
      position: relative;
      z-index: 1;

      @media ${extraSmall}, ${small} {
        margin: 0 auto;
        max-width: 182px;
      }
    }
  }
`

export const Etapa = styled.div`
  display: grid;
  grid-template-columns: 105px minmax(0, 1fr);
  grid-gap: 30px;
  font-weight: 300;
  color: ${globals.colors.darkblue};

  & > div {
    h3 {
      margin-bottom: ${props => (props.centerText ? "0" : "1.45rem")};
    }
  }

  .title-wrapper {
    position: relative;

    span {
      position: absolute;
      font-size: 69px;
      font-weight: 800;
      color: #164d81;
      z-index: 0;
      left: -60px;
      top: -30px;
    }

    h3,
    div {
      position: relative;
    }
  }

  h3 {
    margin: 0;
  }

  p {
    line-height: 1.6;

    a {
      color: white;
      font-weight: bold;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
`

export const EtapaImageWrapper = styled.div`
  width: 90px;
  height: 90px;
  display: flex;
  position: relative;
  text-align: center;
  margin: 22px auto 0;
  justify-content: center;
  background: ${props => (props.bgColor ? props.bgColor : "transparent")};

  img {
    margin: 0;
  }

  .illustration {
    max-height: 42px;
    align-self: center;
    position: relative;
    z-index: 3;
  }

  .circle {
    position: absolute;
    z-index: 1;
    opacity: 0.48;
  }
`

export const CarouselWrapper = styled.div`
  position: relative;
  padding-bottom: 30px;
  margin: 0 auto;

  .react-multi-carousel-dot button {
    width: 7px;
    height: 7px;
    border: none;
    background: #3a3864;
  }

  .react-multi-carousel-dot--active button {
    background: ${globals.colors.lightblue};
  }

  .react-multi-carousel-dot-list {
    li {
      margin: 0;
    }
  }
`

export const ControleCobrancasWrapper = styled.div`
  display: grid;
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px;

  img {
    margin-right: 0;
    margin-left: auto;
    max-width: 66vw;

    @media ${small} {
      max-width: unset;
      width: 100%;
      height: auto;
    }
    @media ${extraSmall} {
      max-width: unset;
      width: 100%;
      height: auto;
    }
  }

  & > div {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);

    @media ${small} {
      position: relative;
    }
    @media ${extraSmall} {
      position: relative;
    }
  }
`

export const ControleCobrancasText = styled.div`
  max-width: 500px;

  h2 {
    color: ${globals.colors.darkblue};
  }

  h5 {
    color: ${globals.colors.lightblue};
  }

  p {
    line-height: 1.6;
    font-weight: 300;
  }
`

export const PostsTitleWrapper = styled.div`
  text-align: center;

  svg {
    display: block;
    margin: 0 auto 20px;
    max-width: 70px;
    //border-radius:50%;
    //overflow:hidden;
    //box-shadow: 4px 11px 25px 0 rgba(50,50,50,0.1);
  }

  h2 {
    color: ${globals.colors.darkblue};
    margin-bottom: 40px;
  }
`

export const PostLink = styled.a`
  display: block;
  background: #f5f9fc;
  padding: 4px;
  text-decoration: none;

  &:hover {
    img {
      opacity: 0.8;
    }
  }

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0;
    transition: all 0.2s;
  }

  & > div {
    padding: 20px 15px;
  }

  time,
  p {
    font-size: 13px;
    font-weight: 300;
    display: block;
    color: ${globals.colors.lightblue};
  }

  time {
    margin-bottom: 10px;
  }

  h6 {
    margin: 0 0 10px 0;
    color: ${globals.colors.darkblue};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`

export const InternalHeader = styled.div`
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;

  @media ${extraSmall}, ${small} {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  h2 {
    color: ${globals.colors.darkblue};
    font-weight: 800;
    font-style: italic;
  }

  p {
    color: #666;
    line-height: 1.6;
    max-width: 950px;
    font-weight: 300;
    margin: 0 auto;
  }
`

export const BlueWrapper = styled.div`
  padding-bottom: 50%;
  height: 0;
  width: 100%;
  position: relative;
  background-color: #ccf2fd;

  @media ${large} {
    padding-bottom: 50%;
  }

  @media ${medium} {
    padding-bottom: 50%;
  }

  @media ${small} {
    padding-bottom: 80%;
  }

  @media ${extraSmall} {
    padding-bottom: 107%;
  }
`

export const BrandList = styled.ul`
  display: flex;
  list-style: none;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0;
  justify-content: space-between;

  @media ${medium} {
    max-width: 666px;
  }

  & > li {
    img {
      @media ${small} {
        width: 80px;
        height: auto;
      }

      @media ${extraSmall} {
        width: 50px;
        height: auto;
      }

      @media ${globals.mediaqueries.medium} {
        width: 101px;
      }
    }
  }
`

export const TitleTiposDebitos = styled(H2)`
  margin-bottom: 20px !important;
`

export const SubtitleTiposDebitos = styled(H5)`
  text-align: center;
  color: #3a3864;
  font-weight: 300;
  line-height: 1.6;
  margin-bottom: 40px;
`

export const FaqImageWrapper = styled.div`
  display: block;
  text-align: center;

  img {
    @media ${extraSmall}, ${small} {
      max-width: 269px;
      margin: 0 auto;
    }
  }
`

export const FaqTitleWrapper = styled.dt`
  padding-top: 20px;
  padding-bottom: 20px;

  & > * {
    display: flex !important;

    svg {
      margin-right: 0;
      margin-left: auto;
    }
  }

  button {
    text-align: left;
    line-height: 1.3;
    display: flex;

    svg {
      > * {
        fill: ${globals.colors.darkblue};
      }
    }

    h4 {
      text-align: left;
      padding-right: 10px !important;
    }
  }
`

export const FaqItemWrapper = styled.div`
  text-align: left;
  border-bottom: 1px solid #cecece;
`

export const FaqItem = styled.dd`
  overflow: hidden;
  transition: max-height 0.4s ease;
  margin: 0;
`

export const ArrowWrapper = styled.div`
  width: 16px;
  display: block;
  transition: transform 0.2s;
  transform: ${props => (props.isActive ? `rotate(180deg)` : "")};
  margin-right: 0;
  margin-left: auto;
`

export const CadastroWrapper = styled.div`
  background: rgb(255, 255, 255);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(215, 244, 253, 1) 100%
  );
  text-align: center;
  display: block;
  width: 100%;
  padding: ${`50px ${paddingSides.normal} 60px`};

  @media ${small} {
    padding-left: ${paddingSides.small};
    padding-right: ${paddingSides.small};
  }

  @media ${extraSmall} {
    padding-left: ${paddingSides.small};
    padding-right: ${paddingSides.small};
  }

  svg {
    width: 180px;
    height: auto;
  }

  h4 {
    font-size: 18px;
    font-family: "Uni Neue";
    max-width: 620px;
    font-weight: normal;
    margin: 0 auto 35px;
    color: ${colors.darkblue};
    line-height: 1.3;
  }
`

export const CoberturasWrapper = styled.div`
  padding: 0 ${paddingSides.normal};
  text-align: center;
  margin-bottom: 60px;

  > h2 {
    font-size: 35px;
    line-height: 45px;
    font-style: italic;
    font-family: "Uni Neue";
    font-weight: 800;
    text-align: center;
    color: ${colors.darkblue};
  }

  > p {
    font-size: 17px;
    line-height: 24px;
    color: ${colors.darkblue};
    font-weight: 300;
    font-family: "Roboto";
    text-align: center;
  }
`

export const CoberturasContainer = styled.div`
  background-color: #fafafa;
  border-radius: 16px;
  filter: drop-shadow(-0.279px 3.99px 3px rgba(0, 0, 0, 0.23));
  padding: 38px 65px;
  max-width: 972px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-gap: 16px;

  div.left {
    text-align: left;
    width: 295px;

    img {
      margin: 0;
    }

    p {
      font-size: 16px;
      line-height: 22px;
      color: ${colors.darkblue};
      font-weight: 300;
      font-family: "Roboto";
      margin-bottom: 16px;
    }

    a {
      font-size: 14px;
      letter-spacing: 0px;
      line-height: 26px;
      text-decoration: underline;
      color: #003f50;
      font-weight: 400;
      font-family: "Roboto";
    }
  }

  div.right {
    div.coberturas {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      & + div.coberturas {
        margin-top: 48px;
      }

      strong {
        font-size: 20px;
        letter-spacing: 0px;
        line-height: 25px;
        color: #113c64;
        font-family: "Uni Neue";
        font-weight: 800;
        text-align: left;
        margin-bottom: 16px;
      }

      div.items {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, 125px);
        grid-gap: 8px;

        div.item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          div.item-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              margin-bottom: 5px;
            }

            span {
              font-size: 16px;
              line-height: 24px;
              color: ${colors.darkblue};
              font-weight: 300;
              font-family: "Roboto";
              text-align: center;
            }
          }
        }
      }
    }
  }

  @media ${extraSmall} {
    padding: 38px 24px;
    grid-template-columns: 1fr;

    div.left {
      width: 100%;
    }

    div.right {
      div.coberturas {
        align-items: center;

        div.items {
          align-items: center;
          justify-content: center;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

          &.col-3 {
            grid-template-columns: repeat(3, minmax(100px, 1fr));
            grid-gap: 0;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 399px) {
    div.right {
      div.coberturas {
        align-items: center;

        div.items {
          align-items: center;
          justify-content: center;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

          &.col-3 {
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            grid-gap: 0;
          }
        }
      }
    }
  }
`

export const AssistenciasWrapper = styled.div`
  padding: 0 ${paddingSides.normal};
  text-align: center;
  margin-bottom: 60px;

  > h2 {
    font-size: 35px;
    line-height: 45px;
    font-style: italic;
    font-family: "Uni Neue";
    font-weight: 800;
    text-align: center;
    color: ${colors.darkblue};
  }

  > p {
    font-size: 17px;
    line-height: 24px;
    color: ${colors.darkblue};
    font-weight: 300;
    font-family: "Roboto";
    text-align: center;
  }
`

export const AssistenciasContainer = styled.div`
  background-color: #fafafa;
  border-radius: 16px;
  filter: drop-shadow(-0.279px 3.99px 3px rgba(0, 0, 0, 0.23));
  padding: 38px 65px;
  max-width: 972px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-gap: 16px;

  div.left {
    text-align: left;
    width: 295px;

    img {
      margin: 0 0 16px 0;
    }

    p {
      font-size: 16px;
      line-height: 22px;
      color: ${colors.darkblue};
      font-weight: 300;
      font-family: "Roboto";
      margin-bottom: 16px;
    }

    a {
      font-size: 14px;
      letter-spacing: 0px;
      line-height: 26px;
      text-decoration: underline;
      color: #003f50;
      font-weight: 400;
      font-family: "Roboto";
    }
  }

  div.right {
    width: 100%;
    justify-content: center;
    align-items: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
  }

  @media ${extraSmall} {
    padding: 38px 24px;
    grid-template-columns: 1fr;
    align-items: center;
    justify-content: center;

    div.left {
      width: 100%;
      text-align: center;
    }

    div.right {
      grid-template-columns: repeat(auto-fill, minmax(125px, 1fr));
    }
  }
`

export const AssistenciaItem = styled.div`
  max-width: 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin: 0 auto;
  position: relative;

  strong.item-title {
    font-size: 20px;
    letter-spacing: 0px;
    line-height: 22px;
    color: #113c64;
    font-family: "Uni Neue";
    font-weight: 800;
    text-align: center;
    margin-bottom: 16px;
    height: 73px;
  }

  img.star {
    margin-top: -40px;
  }

  a.more-info {
    font-size: 14px;
    letter-spacing: 0px;
    line-height: 26px;
    text-decoration: underline;
    color: #003f50;
    font-weight: 400;
    font-family: "Roboto";
    text-align: center;
    cursor: pointer;
  }
`

export const PopoverContent = styled.div`
  width: 271px;
  max-height: 380px;
  border-radius: 11px;
  filter: drop-shadow(-0.279px 3.99px 3px rgba(106,106,106,0.14));
  background-color: #ffffff;
  padding: 16px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > button {
      cursor: pointer;
      background-color: transparent;
      border: none;
      border-radius: 50%;
      color: #113c64;
      align-self: flex-end;
    }

  strong {
    font-size: 13px;
    line-height: 17px;
    color: #113c64;
    font-family: "Roboto";
    font-weight: 900;
    margin-bottom: 10px;
    align-self: flex-start;
  }

  p {
    font-size: 13px;
    line-height: 17px;
    color: #113c64;
    font-weight: normal;
    font-family: "Roboto";
  }
`

export const CTAContainer = styled.div`
  height: 649px;
  background-color: #CAF5FF;
  background-image: url("${HeaderBackground}");
  background-position: bottom right;
  background-position-x: calc(100% - 25px);
  background-size: 600px;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  padding-top: 100px;
  border-bottom: 3px solid #000;

  div.cta-text {
    margin-left: 150px;
    max-width: 565px;

    h1 {
      font-size: 56px;
      letter-spacing: -2px;
      line-height: 59px;
      color: #003864;
      font-style: italic;
      font-family: "Uni Neue";
      font-weight: 800;
    }

    p {
      font-size: 22px;
      line-height: 30px;
      color: #26c3ef;
      font-weight: 500;
      font-family: "Roboto";
    }

    button {
      margin-top:1em;
      background: ${colors.darkblue};
      color:white;
      font-family: ${fonts.headings};

      @media ${small}, ${extraSmall}{
        line-height:1;
        padding-top:8px;
        padding-bottom:8px;
      }

      &:hover {
        background: ${lighten(0.1, colors.darkblue)};
        color: white;
      }

      &:active {
        background: ${darken(0.15, colors.darkblue)};
        color: white;
      }
    }
  }

  @media ${large} {
    align-items: center;

    div.cta-text {
      margin-top: -32px;
      margin-left: 25px;
      max-width: 565px;
    }
  }

  @media ${medium} {
    align-items: center;
    background-size: 50%;
    background-position: bottom right;
    background-position-x: calc(100% - 25px);

    div.cta-text {
      margin-top: 32px;
      margin-left: 25px;
    }
  }

  @media ${small} {
    align-items: center;
    justify-content: center;
    background-image:none;



    div.cta-text {
      margin-top: -32px;
      margin-left: 0;
      text-align: center;

      h1 {
        font-size: 42px;
        margin-bottom: 8px;
      }

      p {
        font-size: 22px;
        margin-bottom: 8px;
      }
    }
  }


  @media ${extraSmall} {
    align-items: flex-start;
    justify-content: center;
    background-image:none;
    height: 528px;

    div.cta-text {
      margin-top: 32px;
      margin-left: 0;
      text-align: center;

      h1 {
        font-size: 35px;
        margin-bottom: 8px;
      }

      p {
        font-size: 18px;
        margin-bottom: 8px;
      }
    }
  }
`
